export const openNewTicketForm = () => {
  window.open(
    'https://procursys.freshdesk.com/support/tickets/new',
    '_blank',
  );
};
